import React from 'react';
import './ResultsFiltering.scss';
import { SearchBox, SortBy, useHitsPerPage } from "react-instantsearch-hooks-web";

import { useMenu, UseMenuProps } from 'react-instantsearch-hooks-web';
import Util from '../../../../../../../src/js/Util';

export function MenuSelect(props: UseMenuProps) {
    const { items, refine } = useMenu(props);
    const { value } = items.find(({ isRefined }) => isRefined) || {};

    return (
        <div className="selectmenu">
            <select
                onChange={(event) => {
                    refine(event.target.value);
                }}
                value={String(value)}
            >
                <option value="">
                    {Util.translate('All Products')}
                </option>
                {items.map((item) => (
                    <option key={item.value} value={String(item.value)}>
                        {item.label}
                    </option>
                ))}
            </select>
        </div>
    );
}

function CustomHitsPerPage(props) {
    const { items, refine } = useHitsPerPage(props);
    const { value } = items.find(({ isRefined }) => isRefined) || {};

    return (
        <div className="selectmenu">
            <select
                onChange={(event) => {
                    refine(Number(event.target.value));
                }}
                value={String(value)}
            >
                {items.map((item) => (
                    <option key={item.value} value={String(item.value)}>
                        {item.label}
                    </option>
                ))}
            </select>
        </div>
    );
}

export class ResultsFiltering extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="results-filtering">
                <div className="container">
                    <div className="results-filtering-search">
                        <SearchBox onSubmit={() => { this.props.hideFilterModal() }} placeholder={Util.translate('Enter Keyword')} />
                    </div>

                    <div className="results-filtering-option">
                        <MenuSelect attribute={'mint_status.' + SUMA.language} />
                    </div>

                    <div className="results-sorting">
                        <SortBy items={[
                            { label:Util.translate('Default Order'), value: this.props.indexName },
                            { label:Util.translate('Newest Release'), value: this.props.indexName + '_date_desc' },
                            { label:Util.translate('Alphabetical'), value: this.props.indexName + '_name_asc' },
                            { label:Util.translate('Price: Low to High'), value: this.props.indexName + '_price_asc' },
                            { label:Util.translate('Price: High to Low'), value: this.props.indexName + '_price_desc' },
                            { label:Util.translate('Lowest Premium'), value: this.props.indexName + '_premium_asc' },
                            { label:Util.translate('Highest Premium'), value: this.props.indexName + '_premium_desc' },
                            { label:Util.translate('On Sale'), value: this.props.indexName + '_sale_asc' }
                        ]} />
                    </div>
                    <div className="results-filtering-option">
                        <CustomHitsPerPage {...this.props.hitsPerPage} />
                    </div>
                </div>
            </div>
        );
    }

}
